import React, { useRef, useState } from 'react'
import ThisProject from '../ThisProject';
import MotionContent from '../../components/containers/MotionContent';
import { DefaultContent, ImageMedia, Section, SectionTitle, TextBox, VideoShort } from '../../components/imports';
import { motion } from 'framer-motion';
import SheetWrapper from '../../components/containers/SheetWrapper';
import Reactions from '../../components/common/Reactions';
import useComments from '../../hooks/modals/useComments';

const Content = () => {

  const reviewsRef = useRef(null);

  // TODO: ADD KEYWORD TRIGGER FOR EXPLANATION: blue ocean
  /* La stratégie Blue Ocean en affaires se réfère à la création de nouveaux marchés sans concurrence, où une entreprise peut se démarquer et prospérer. Contrairement aux océans rouges, qui sont des marchés saturés de concurrence acharnée, les océans bleus sont des espaces inexplorés où la demande est créée plutôt que disputée. Cette stratégie vise à innover et à offrir une proposition unique, en se concentrant sur la différenciation et la valeur ajoutée, plutôt que de se battre pour une part du marché existant. L'objectif est d'attirer de nouveaux clients tout en rendant la concurrence obsolète. */

  const s1 = {
    title: "Pre-Lancement (Teasing)",
    descr: "A une semaine, compte à rebours lancé, nous attaquons Instagram pour lancer l'enquête. Qu'est ce que vous nous préparez? "
  }
  const s2 = {
    title: "Video de lancement",
    descr: "5 Aôut 2022, 21H00 GMT, Nak'Ala lance officiellement son produit au rythme d'une animation 3D signée LAWWD. "
  }
  const s3 = {
    title: "Après lancement",
    descr: "Le lancement n’était que le début. Post-lancement, la stratégie s’est recentrée sur le contenu organique, pensé pour engager et fédérer une communauté. Formats courts, capsules immersives, storytelling de marque, chaque contenu était une pièce du puzzle pour ancrer Nak’Ala dans l’esprit du public. Plus qu’une marque, une révolution laitière, portée par une stratégie où innovation créative et impact se mêlent. 🚀🐄🔥"
  }

  const countdownRef = useRef(null);
  const mentheRef = useRef(null);
  const reelRef = useRef(null);

  const { isOpen/* , onOpen */, onClose } = useComments();
  console.log("State of isOpen ", isOpen)

  const [sheet /* , setSheet */] = useState(isOpen)
  const onChange = (open) => {
    if (!open) {
      onClose();
    }
  }

  return (
    <ThisProject>
      {({ thisProject, projectId, prLink, comments }) => {

        // const { isOpen } = comments;

        return (
          <>

            <div className='projectContent min-h-screen h-full overflow-y-auto '>

              {/* <MotionContent height={"h-fit w-full bg-black lg:h-[90vh]"} translateRange={["10%", "-5%"]}  >
            <ImageMedia src={require('./assets/SCN09_Nakala_N_003.png')} />
          </MotionContent> */}

              {/* TEASE */}
              <Section padded className='bg-gradient-to-b from-blakk to-black flex relative flex-col w-full'>
                <div className='flexResp items-center resp gap-12 paddingY'>
                  <TextBox title={"Intrépides et visionnaires"} vertical
                    descr={
                      <>
                        La magie opérant dans les premiers échanges sur ce projet fut belle. Un projet ambitieux, une approche innovante, et surtout, une envie commune de bousculer les codes du marché. Dès le départ, nous savions que Nak’Ala ne pouvait pas se contenter d’être un nouvel acteur parmi tant d’autres : il devait créer son propre terrain de jeu. <br /><br /> L’idée ? Raconter une histoire, donner une âme à la marque, bien au-delà du simple produit. Pour son lancement, nous avons imaginé une animation 3D immersive, un teaser percutant où notre vache mascotte ne se contenterait pas d’exister, mais de captiver. Une mise en scène soignée, un univers visuel unique, et surtout, un ton qui casse avec l’image classique des produits laitiers. Ici, pas de vaches paisibles dans des champs verdoyants… mais une héroïne déterminée 🐮, prête à défier les dinosaures du marché.🦕💥
                      </>
                    }
                  />
                  <div className='flex center relative w-full max-h-[80svh] overflow-hidden border border1'>
                    <VideoShort
                      title="countdown"
                      videoRef={countdownRef}
                      loop={false}
                      showControls
                      src={require('./assets/tease/nakala_countdown_lawwd.MOV')}
                      css='full scale-[102%] origin-left'
                    />
                  </div>
                </div>
              </Section>
              {/* TEASE */}
              <Section padded className={"bg-black gap-8"}>
                <SectionTitle {...s1} className={"max-sm:px-6= !resp "} />
                <div className='resp grid grid-cols-1 md:landscape:grid-cols-2 gap-2 lg:gap-4 paddingX *:rounded-md *:max-h-[65vh] *:border *:border1'>
                  <ImageMedia src={require('./assets/tease/1/R013_Label_002.png')} />
                  <ImageMedia src={require('./assets/tease/1/R013_Label_003.png')} />
                  <ImageMedia src={require('./assets/tease/1/R013_Label_005.png')} />

                  <ImageMedia src={require('./assets/tease/2/SCN03_r01_CapsFlying.png')} />
                  <ImageMedia src={require('./assets/tease/2/NKL_Still023.png')} />
                  <ImageMedia src={require('./assets/tease/2/R013_Label_001.png')} />
                  <div className='flex center relative object-cover overflow-clip'>
                    <VideoShort
                      title="menthe"
                      videoRef={mentheRef}
                      src={require('./assets/loops/R_test_Menthe.mp4')}
                      css='full scale-[102%] origin-left'
                    />
                  </div>
                  <ImageMedia src={require('./assets/tease/3/Nakala_T_001.png')} />
                  <ImageMedia className="" src={require('./assets/tease/3/Nakala_3_R004.png')} />
                </div>
              </Section>

              {/* REEL */}
              <Section className={"bg-gradient-to-b from-black via-black to-blakk !pb-0 h-fit w-full gap-8"}>
                <SectionTitle {...s2} className={"max-sm:px-6= !resp "} />
                <MotionContent height={"h-fit lg:h-[90%]"} className={"w-full resp center"} translateRange={["0%", "0%"]} offsetRange={["start end", "end center"]} scaleRange={[1, 1]}>
                  <VideoShort
                    title="reel"
                    isMuted={true}
                    showControls
                    videoRef={reelRef}
                    src={require('./nakala.mov')}
                    css='full scale-[102%]= h-fit !object-contain origin-center border border1'
                  />
                </MotionContent>
                {/* REACTIONS */}

                {/* REACTIONS */}
                {(!thisProject || !thisProject.metadata?.reviews) ? null :
                  <SheetWrapper resp key={"Comments"} isOpen={sheet} setIsOpen={onChange}  >
                    <div ref={reviewsRef} className='w-full relative flex flex-col z-[2] pb-20'>
                      <TextBox title={`Reactions de la communauté Instagram sur le projet ` + String(thisProject.client).toLocaleUpperCase()} />
                      <div className='resp= flex flex-col w-full gap-2 text-white'>
                        <motion.div initial={{ translateY: "60px" }} className='w-fit flex flex-col lg:flex-row py-6 max-sm:divide-y lg:divide-x divide-neutral-500/10 items-start gap-2 relative mx-auto '>
                          {thisProject.metadata.reviews.map((review, i) => {
                            return (
                              <div key={i} className='flex flex-col w-full h-full lg:w-full md:maxW2 text-white rounded-lg bg-gray-600/5 hover:bg-gray-500/10 items-start p-4 *:text-base'>
                                <div className='size-6 rounded-full mb-2 flex center relative'>
                                  <DefaultContent />
                                </div>
                                <p className='text-white nowrap'>{review.from}</p>
                                <p className='min-w-16= text-inherit dim1 max-w-[40ch] mt-12'>{review.text}</p>
                              </div>
                            )
                          })}
                        </motion.div>
                      </div>
                    </div>
                  </SheetWrapper>
                }
                {thisProject.metadata?.reviews &&
                  <div className='resp'>
                    <Reactions type={["likes", "comments"]} project={thisProject.client} >
                      <div ref={reviewsRef} className='w-full relative flex z-[2] pb-20'>
                        <div className='resp flex flex-col w-full gap-2 text-white'>
                          <motion.div initial={{ translateY: "60px" }} className='w-fit flex flex-col lg:flex-row py-6 max-sm:divide-y lg:divide-x divide-neutral-500/10 items-start gap-2 relative mx-auto '>
                            {thisProject.metadata.reviews.map((review, i) => {
                              return (
                                <div key={i} className='flex flex-col w-full h-full lg:w-full md:maxW2 text-white rounded-lg bg-gray-600/5 hover:bg-gray-500/10 items-start p-4 *:text-base'>
                                  <div className='size-6 rounded-full mb-2 flex center relative'>
                                    <DefaultContent />
                                  </div>
                                  <p className='text-white nowrap'>{review.from}</p>
                                  <p className='min-w-16= text-inherit dim1 max-w-[40ch] mt-12'>{review.text}</p>
                                </div>
                              )
                            })}
                          </motion.div>
                        </div>
                      </div>
                    </Reactions>
                  </div>
                }



                {/* <div key={i} className='inline space-x-3 w-full lg:w-full md:maxW2 text-white rounded-lg hover:bg-gray-500/10 items-start p-2 *:inline *:text-base'>
              <p className='text-white nowrap'>{review.from}</p>
              <p className='min-w-16= text-inherit dim1 max-w-[40ch]= '>{review.text}</p>
            </div >*/}
              </Section>

              {/* RENDERS */}
              <Section padded className={"bg-gradient-to-t from-black to-blakk gap-8"}>
                <SectionTitle {...s3} className={"!resp "} />
                <div className='grid grid-cols-1 md:landscape:grid-cols-3 gap-2 pt-16 lg:gap-4 resp *:w-full *:rounded-md *:border *:border1'>
                  <ImageMedia src={require('./assets/renders/s1/Nakala_R0151_Vanille.png')} />
                  <ImageMedia src={require('./assets/renders/s1/Nakala_R0140_Menthe.png')} />
                  <ImageMedia src={require('./assets/renders/s1/Nakala_R010.png')} />

                  <ImageMedia className="object-cover min-h-[80vh]" src={require('./assets/renders/s2/Nakala_R014.png')} />
                  <ImageMedia className="max-h-[50vh]" src={require('./assets/renders/s2/Nakala_R003_8Bit.png')} />
                  <ImageMedia className="max-h-[50vh]" src={require('./assets/renders/s2/Nakala_R004.png')} />

                  <ImageMedia src={require('./assets/renders/s2/Nakala_Packs_6_colorgraded.png')} />
                  <ImageMedia src={require('./assets/renders/s2/Nakala_Packs_18.png')} />
                  <ImageMedia src={require('./assets/renders/s2/Nakala_Packs_30_v2.png')} />
                </div>
              </Section>


              {/*   <Section className={"resp"}>
            <TextBox title={"Magic in the making"} />
            <div className='flexResp'>
              <div className='w-full flex flex-col'>
                <video
                  autoPlay muted loop
                  playsInline
                  className="h-fit object-contain brightness-105 border border1"
                  controlsList="nodownload"
                  onContextMenu={(e) => e.preventDefault()}
                >
                  <source src={require('./assets/flipsim/R001_TestViewport Sim1_25FPS.mp4')} className='' />
                </video>

                <video
                  autoPlay muted loop
                  playsInline
                  className="h-fit object-contain brightness-105 border border1"
                  controlsList="nodownload"
                  onContextMenu={(e) => e.preventDefault()}
                >
                  <source src={require('./assets/flipsim/SCN009_Shake_i1_.mp4')} className='' />
                </video>

              </div>
              <div className='grid grid-cols-1 w-fit gap-2 lg:gap-4 resp *:rounded-md *:border *:border1'>
                <ImageMedia className="relative" src={require('./assets/flipsim/R001_TestViewport Sim1_0002.png')} tag="Généré" />
                <ImageMedia className="relative" src={require('./assets/flipsim/R001_TestViewport Sim1_0067.png')} tag="Populé" />
                <ImageMedia className="relative" src={require('./assets/flipsim/R001_TestViewport Sim1_0360.png')} tag="Au repos" />
              </div>
            </div>
          </Section> */}

            </div>


          </>
        )
      }}
    </ThisProject>
  )
}

export default Content